import { useState } from 'react';

export const useToggle = () => {
  const [toggle, setToggle] = useState<boolean>(false);
  const toggleStatus = () => setToggle((prevState) => !prevState);
  const toggleOff = () => setToggle(false);
  return { toggle, toggleStatus, toggleOff };
};
